import categoryStyle from './category.module.css'


//export default function Category({ category, onClick, children }) {
//    return <div className={categoryStyle.category} onClick={e => onClick(category._id)} >
//        {children}
//    </div>
//}

//updated once new category added for registration:
export default function Category({ category, onClick, children }) {
    const handleClick = () => {
        if (category && category._id) {
            onClick(category._id); // for regular categories
        } else {
            onClick(); // for special case like "register"
        }
    };

    return (
        <div className={categoryStyle.category} onClick={handleClick}>
            {children}
        </div>
    );
}